class TenantUtils {
    static isAgraga() {
        let tenant = process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE
        if (!tenant || !tenant.length) tenant = 'agraga'
        if (tenant === 'agraga') return true
        return false
    }
    static isNavexel() {
        if (process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE === 'navexel') return true
        return false
    }
}
export default TenantUtils